import { useEffect, useMemo, useRef } from 'react';
import { useRouteError, useNavigate } from 'react-router-dom';
import {
  ButtonTypes, EmptyState, EmptyStateSizes, EmptyStateTypes, FeaturedIconColors,
} from '@leegality/leegality-react-component-library';
import { useErrors } from '@app/store';
import { notification } from '@components/notification';
import { iconRenderer, IconKeys, IconColors } from '@components/icon';
import { RL } from '@constants';
import { getTranslation } from '@utils';

const Error = () => {
  const errors = useErrors();
  const routeError = useRouteError();
  const navigate = useNavigate();
  const notifiedRef = useRef(false);

  const messages = useMemo(() => {
    const collected = [];
    if (errors?.length > 0) {
      errors.forEach((err) => collected.push(err.message));
    }
    if (routeError?.data) {
      collected.push(routeError.data);
    }
    if (routeError?.message && !collected.includes(routeError.message)) {
      collected.push(routeError.message);
    }
    if (collected.length === 0) {
      collected.push(getTranslation('SOMETHING_WENT_WRONG_LABEL'));
    }
    return collected;
  }, [errors, routeError]);

  useEffect(() => {
    if (notifiedRef.current) return;
    notifiedRef.current = true;
    notification.error(getTranslation('ERROR_OCCURRED_LABEL'), messages.join('. '));
  }, [messages]);

  return (
    <div className="flex items-center justify-center h-screen p-6 bg-white">
      <EmptyState
        type={EmptyStateTypes.CUSTOM}
        size={EmptyStateSizes.MEDIUM}
        color={FeaturedIconColors.ERROR}
        renderIcon={() => iconRenderer({ iconName: IconKeys.AlertTriangle, color: IconColors.ERROR })}
        text={getTranslation('ERROR_OCCURRED_LABEL')}
        supportingText={messages.join('. ')}
        buttonProps={[
          {
            type: ButtonTypes.SECONDARY,
            label: getTranslation('GO_TO_HOME_LABEL'),
            onClick: () => navigate(RL.ROOT, { replace: true }),
          },
          {
            type: ButtonTypes.PRIMARY,
            label: getTranslation('TRY_AGAIN_LABEL'),
            onClick: () => window.location.reload(),
          },
        ]}
      />
    </div>
  );
};

export default Error;
